import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { modal } from 'react-redux-modal';
import { FeedbackModal, ContactUsModal, VolunteerModal } from '../../components';

import './styles.scss';

class Footer extends React.Component {

  constructor(props) {
    super(props);
    this.launchFeedback = this.launchFeedback.bind(this);
    this.launchContactUs = this.launchContactUs.bind(this);
    this.launchVolunteer = this.launchVolunteer.bind(this);
  }

  launchFeedback(e) {
    if (e) e.preventDefault();
    modal.add(FeedbackModal, {size:'medium', hideTitleBar: true});
  }

  launchContactUs(e) {
    if (e) e.preventDefault();
    modal.add(ContactUsModal, {size:'medium', hideTitleBar: true});
  }

  launchVolunteer(e) {
    if (e) e.preventDefault();
    modal.add(VolunteerModal, {size:'medium', hideTitleBar: true});
  }

  render() {
    const {comingSoon} = this.props;
    return (
    <div className="footer">
        <div className="container-fluid content">
          <div className="row">
              <div className="col-12 col-sm-4 mb-4 mb-md-0">
                <div className="footer-heading first u-font-foundation-roman">Our Mission</div>
                <p className="footer-description">To champion the selfless acts of others, create a portal into the soul of humanity and inspire lifelong learning.</p>
                <p className="footer-description">Explore.org is the world&apos;s leading philanthropic live nature cam network and documentary film channel.</p>
              </div>
              <div className="col-12 col-sm about-explore mb-4 mb-md-0">
                <div className="footer-heading u-font-foundation-roman">About Explore</div>
                <ul className="footer-ul">
                  <li><Link to="/about-us">About Us</Link></li>
                  <li><Link to="/testimonials">Testimonials</Link></li>
                  <li><Link to="/community-guidelines">Community Guidelines</Link></li>
                  <li><Link to="/youtube-community-guidelines">Youtube Community Guidelines</Link></li>
                  <li><Link to="/support/contact" onClick={(e) => {
                    this.launchContactUs(e);
                  }}>Contact Us</Link></li>
                  <li><a href="https://files.explore.org/files/Explore_Website_Handbook.pdf" target="_blank">Explore
                    Website Handbook</a></li>
                  <li><Link to="/grants">Grants Awarded</Link></li>
                  <li><Link to="/extra/feedback" onClick={(e) => {
                    this.launchFeedback(e);
                  }}>Feedback</Link></li>
                  <li><Link to="/press">Press</Link></li>
                  {/* <li><Link to="/extra/download_url" onClick={(e)=>{comingSoon(e)}}>Download Mobile Apps</Link></li> */}
                  {/* <li><Link to="/extra/partnerships" onClick={(e)=>{comingSoon(e)}}>Partnerships</Link></li> */}
                  <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                  <li><a href="https://www.youtube.com/t/terms" target="_blank">YouTube Terms of Service</a></li>
                  <li><Link to="/youtube-privacy-policy">YouTube API Privacy Policy</Link></li>
                  <li><Link to="/terms-of-service">Terms of Service</Link></li>
                  <li><Link to="/support/volunteer" onClick={(e) => {
                    this.launchVolunteer(e);
                  }}>Volunteer</Link></li>
                </ul>

                <div className="footer-heading u-font-foundation-roman">Website Sections</div>
                <ul className="footer-ul">
                <li><Link to="//blog.explore.org" target="_blank">Blog</Link></li>
                  {/* <li><Link to="/education" onClick={(e)=>{comingSoon(e)}}>Education</Link></li> */}
                  <li><Link to="/films">Films</Link></li>
                  {/* <li><Link to="/interviews" onClick={(e)=>{comingSoon(e)}}>Interviews</Link></li> */}
                  <li><Link to="/help">Frequently Asked Questions</Link></li>
                  <li><Link to="/livecams">Livecams</Link></li>
                  {/* <li><Link to="/members">Members</Link></li> */}
                  <li><Link to="/subscribe">Newsletter</Link></li>
                  <li><Link to="/pearls-of-the-planet">Pearls of the Planet</Link></li>
                  {/* <li><Link to="/photography">Photography</Link></li> */}
                  {/* <li><Link to="/press" onClick={(e)=>{comingSoon(e)}}>Press</Link></li> */}
                  <li><a href="/snapshots/favorites/">Snapshots</a></li>
                </ul>
              </div>

              <div className="col-12 col-sm p-md-0">
                <div className="footer-heading u-font-foundation-roman">Follow Us</div>
                <ul className="footer-ul">
                  <li><a target="_blank" href="https://www.facebook.com/ExploreOrg/">Facebook | explore.org</a></li>
                  <li><a target="_blank" href="https://facebook.com/exploredogs">Facebook | dog bless you</a></li>
                  <li><a target="_blank" href="https://facebook.com/explorecats">Facebook | cat bless you</a></li>
                  <li><a target="_blank" href="https://instagram.com/exploreorg">Instagram</a></li>
                  <li><a target="_blank" href="https://pinterest.com/exploreorg">Pinterest</a></li>
                  <li><a target="_blank" href="https://soundcloud.com/exploreorg">Soundcloud</a></li>
                  <li><a target="_blank" href="https://twitter.com/exploreorg">Twitter</a></li>
                  <li><a target="_blank" href="https://www.youtube.com/user/exploreTeam">YouTube | explore films</a></li>
                  <li><a target="_blank" href="https://www.youtube.com/channel/UCiGOIXjFqy5_mUNxQNOMfHw">YouTube | explore africa</a></li>
                  <li><a target="_blank" href="https://www.youtube.com/channel/UC8NnosPOvXnm0O1u5YnLQiw">YouTube | explore birds bats bees</a></li>
                  <li><a target="_blank" href="https://www.youtube.com/channel/UC2Sk0aXLq3ADkH_USGPKT_Q">YouTube | explore bears &amp; bison</a></li>
                  <li><a target="_blank" href="https://www.youtube.com/channel/UC6B91hbZkdiDjWdu00QCcew">YouTube | explore cats lions tigers</a></li>
                  <li><a target="_blank" href="https://www.youtube.com/channel/UCfC0RcYzDQcFtHrce2mpvbA">YouTube | explore dogs</a></li>
                  <li><a target="_blank" href="https://www.youtube.com/channel/UCMWAvusUV2eeVVHZDKiMKrw">YouTube | explore farm life</a></li>
                  <li><a target="_blank" href="https://www.youtube.com/channel/UCSyg9cb3Iq-NtlbxqNB9wGw">YouTube | explore oceans</a></li>
                  <li><a target="_blank" href="https://www.youtube.com/channel/UCUtGnX65osNPQ98Y3-SSgpg">YouTube | explore zen den</a></li>

                </ul>
              </div>
          </div>
        </div>
        <div className="footer-legal">
          <div className="container">
            <div className="row">
              <div className="col-12">
                &copy; {moment().format('YYYY')} Explore Annenberg LLC &nbsp; All Rights Reserved
              </div>
            </div>
          </div>
        </div>

    </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {};
};
export default connect(mapStateToProps)(Footer);
